import { FC } from 'react'

import { StatsBlock } from 'src/Components/StatsSectionBlock'
import {
  CampaignStatusEnum,
  TikTokCampaignPricingModelEnum,
} from 'src/Types/campaigns'
import { numberFormatCommas } from 'src/Constants/functions'

interface StatsBlockContainerProps {
  viewsCount?: number
  commentsCount?: number
  likesCount?: number
  videosCount?: number
  campaignStatus?: CampaignStatusEnum
  pricingModel?: TikTokCampaignPricingModelEnum
}

export const StatsBlockContainer: FC<StatsBlockContainerProps> = ({
  viewsCount,
  commentsCount,
  likesCount,
  videosCount,
  campaignStatus,
  pricingModel,
}) => {
  if (!campaignStatus) {
    return null
  }

  const isVideosBased =
    pricingModel === TikTokCampaignPricingModelEnum.VideosBased

  const sections = isVideosBased
    ? [
        {
          title: 'Views',
          value: numberFormatCommas(viewsCount),
        },
        {
          title: 'Comments',
          value: numberFormatCommas(commentsCount),
        },
        {
          title: 'Likes',
          value: numberFormatCommas(likesCount),
        },
      ]
    : [
        {
          title: 'Comments',
          value: numberFormatCommas(commentsCount),
        },
        {
          title: 'Likes',
          value: numberFormatCommas(likesCount),
        },
        {
          title: 'Videos',
          value: videosCount,
          hintText:
            'Videos with a "Rejected" status are excluded from the campaign results and are not charged.',
        },
      ]

  const isStatsBlockHidden =
    [
      CampaignStatusEnum.AWAITING_REVIEW,
      CampaignStatusEnum.PENDING,
      CampaignStatusEnum.SCHEDULED,
    ].includes(campaignStatus) ||
    ([
      CampaignStatusEnum.RUNNING,
      CampaignStatusEnum.STOPPED,
      CampaignStatusEnum.CANCELED,
      CampaignStatusEnum.CANCELED_BY_ADMIN,
    ].includes(campaignStatus) &&
      !videosCount)

  if (isStatsBlockHidden) {
    return null
  }

  return <StatsBlock sections={sections} $isHorizontal />
}
